export const ModelRole = {
  TranslationMain: 'translation_main',
  TranslationWeak: 'translation_weak',
  ImageDescription: 'image_description',
} as const

export type ModelRole = (typeof ModelRole)[keyof typeof ModelRole]

export const ModelRoles = Object.values(ModelRole) as ModelRole[]

export const ReasoningEffort = {
  None: 'none',
  Minimal: 'minimal',
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  XHigh: 'xhigh',
} as const

export type ReasoningEffort = (typeof ReasoningEffort)[keyof typeof ReasoningEffort]

export const ReasoningEffortOrder: ReasoningEffort[] = [
  ReasoningEffort.None,
  ReasoningEffort.Minimal,
  ReasoningEffort.Low,
  ReasoningEffort.Medium,
  ReasoningEffort.High,
  ReasoningEffort.XHigh,
]

export function sortReasoningEfforts(efforts: readonly ReasoningEffort[]): ReasoningEffort[] {
  const order = new Map(ReasoningEffortOrder.map((effort, index) => [effort, index]))
  return [...new Set(efforts)].sort((left, right) => (order.get(left) ?? Number.MAX_SAFE_INTEGER) - (order.get(right) ?? Number.MAX_SAFE_INTEGER))
}

export interface OpenRouterModel {
  id: string
  name: string
  architecture: {input_modalities: string[]}
  supported_parameters: string[]
  reasoning: {supported_efforts: ReasoningEffort[]} | null
  pricing: {prompt: string; completion: string}
}

export interface OpenRouterCatalog {
  models: OpenRouterModel[]
  lastSuccessfulRefreshAt: string | null
  lastError: string | null
}

export interface ModelRoleConfig {
  role: ModelRole
  model: string | null
  reasoning: ReasoningEffort | null
  missingModel: boolean
  compatibleModels: OpenRouterModel[]
}

export interface ModelSettingsResponse {
  catalog: {
    lastSuccessfulRefreshAt: string | null
    modelCount: number
    lastError: string | null
  }
  roles: ModelRoleConfig[]
}
